import { ThemeConfig } from "../types";
import SectionVerticalDivider from "../components/section-vertical-divider";
import BackgroundImageFullGrid from '../components/background-image-full-grid';

const footballTheme: ThemeConfig = {
    id: "football",
    name: "Football",
    backgroundColor: "transparent",
    textColor: "#ffffff",
    hideGridsWhenPlayingMedia: true,
    gridColor: `rgba(255, 255, 255, .5)`,
    maxMediaWidth: 648,
    gridOffset: undefined,
    gridLineThickness: undefined,
    fullGrid: BackgroundImageFullGrid,
    codification: ["heading", "ticker"],
    useHeadingMedia: true,
    enableScrim: true,
    showQr: false,
    footer: {
        showIconDividers: true,
    },
    sequence: {
        headlineSwitchDuration: 6_000,
        mediaDuration: 6_000,
        mediaGap: 1_000,
        playMediaInterval: 12_000,
    },
    leftBorder: {
        marginRight: 10,
        thickness: 0,
    },
    style: {
        headline: {
            fontSize: 49,
            marginTop: 5,
            lineHeight: 45,
            letterSpacing: '-0.02em',
            fontFamily: "helvetica-neue-medium",
        },
        eyebrow: {
            fontFamily: 'helvetica-neue',
            fontSize: 14,
            lineHeight: 14.4,
            fontWeight: 500,
            marginTop: 5,
        },
        qrContent: {
            fontFamily: 'helvetica-neue',
            fontSize: 13,
            lineHeight: 13,
            letterSpacing: '-0.02em',
            fontWeight: 500,
        },
        ticker: {
            fontFamily: "helvetica-neue-hoi",
            fontSize: 34,
            lineHeight: 34,
            paddingTop: '12px',
            fontWeight: 'bold',
            textTransform: 'uppercase',
        }
    },
};

export default footballTheme;